import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { CareerPathPage } from './CareerPathPage';

export function CareerPathPageContainer() {
  const { careerPaths, careerCategories } = useAppSelector((state) => state.careerPath);

  return <CareerPathPage careerCategories={careerCategories} careerPaths={careerPaths} />;
}
